export default __webpack_public_path__ + "2cc11b57b081727dab5d6078bf4bf9c6.svg";